module.exports = "<div class=\"dashboard-user\">\n    <dashboard-subscribed class=\"dashboard-user__new\" />\n</div>"